module.exports = __webpack_public_path__ + "6a7852af57f427df9f7b5a2daa5fe059.pdf";